import React, { useEffect, useState } from "react";
import bg from '../assets/images/LMS-bg.jpg'
import Spinner from './spinner/spinner'
const LMS_API_URL = process.env.REACT_APP_LMS_API_URL;
const LMS_ID = process.env.REACT_APP_LMS_ID;

const SampleModuleFurtherReading = () => {
    const [sessions, setSessions] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                // Step 1: Get all session image data
                const res = await fetch(
                    LMS_API_URL + "furtherReading/get/getFurtherReadingDetailsByModuleId/" + LMS_ID
                );
                const data = await res.json();
                setLoading(false)

                // Step 2: For each session, get the presigned URL
                const images = data?.data?.FurtherReadingDetails.map((item) => {
                    const imageUrl = item?.imageDetails[0]?.imageUrl;
                    return { ...item, imageUrl };
                }
                );
                setSessions(images || []);
            } catch (err) {
                setLoading(false)
                setSessions([])
                console.error("Error fetching:", err);
            }
        };

        fetchSessions();
    }, []);

    return (
        loading ? <Spinner /> :
            <div className="container py-4" >
                {/* Header Section */}
                {sessions && sessions.length > 0 ?
                    <>
                        <div className="text-center mb-4">
                            <h2 className="fw-bold">Further Reading</h2>
                        </div>

                        {/* Card Layout */}

                        <div className="py-3 px-md-5 px-2">
                            {sessions?.map(sess =>
                                <div className="row shadow-lg mb-5 border rounded-5 p-md-5 p-3" style={{
                                    backgroundImage: `url(${bg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: 'no-repeat'
                                }}>
                                    <div className="col-md-6 offset-md-3 d-flex justify-content-center align-items-center">
                                        <img src={sess?.imageUrl} alt="Offsession reading" className="rounded" loading="lazy" width={'100%'} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                    : <p className="text-center">Will Be Added Shortly</p>}
            </div>
    );
}

export default SampleModuleFurtherReading